export default __webpack_public_path__ + "2d978269ef53a175efcfb03b2e514f39.png";